// extracted by mini-css-extract-plugin
export default {"imageContainer":"_76CdF0NfqI7BHB1OJ9JcuP b-profile-card__image-container"};